import { useEffect } from 'react';
import urlTemplate from 'url-template';
import type { Uuid } from 'src/apis/api-utilities';
import type { AuctionResponse } from 'src/apis/transport-auction/types';
import type { OptionalTransportAuctionServiceRootRequest } from 'src/apis/transport-auction/use-transport-auction-service-root';
import { useAxios, type Successful } from 'src/hooks/use-axios';
import { NotFound } from 'src/utils/errors';

type HookOptions = {
  root: Successful<OptionalTransportAuctionServiceRootRequest>;
  tileId: Uuid;
  auctionId: Uuid;
};

type ExecuteOptions = {
  url: string;
};

export function useAuction({ root, tileId, auctionId }: HookOptions) {
  const auctionTile = useAxios(
    (axios, baseConfig, { url }: ExecuteOptions) =>
      axios.request<AuctionResponse>({
        ...baseConfig,
        url,
      }),
    { neededOnPageLoad: true }
  );

  const auctionLink = root.response.data._links.auctionOfAuctionTile;

  useEffect(() => {
    if (!auctionLink) return;

    const url = urlTemplate
      .parse(auctionLink.href)
      .expand({ tileId, auctionId });
    auctionTile.execute({ url });
    // oxlint-disable-next-line exhaustive-deps
  }, [auctionLink, tileId, auctionId]);

  if (!auctionLink) throw new NotFound();

  return auctionTile;
}

export type AuctionRequest = ReturnType<typeof useAuction>;
